import {asyncLoader} from '../async-loader/winelist-async-loader'
import applogger from '@applogger'

const sortProductCatalog = (catalog, sortOrder) => {
  if (Object.entries(sortOrder).length !== 0) {
    return catalog.sort((a, b) => {
      return sortOrder.indexOf(a['id']) - sortOrder.indexOf(b['id'])
    })
  }
  else {
    return catalog.sort((a, b) => {
      if (Object.prototype.hasOwnProperty.call(a, 'sticky') && Object.prototype.hasOwnProperty.call(b, 'sticky')) {
        if (a.sticky > b.sticky) return 1
        if (a.sticky < b.sticky) return -1
      }
      if (Object.prototype.hasOwnProperty.call(a, 'order') && Object.prototype.hasOwnProperty.call(b, 'order')) {
        if (a.order > b.order) return 1
        if (a.order < b.order) return -1
      }
      return 0
    })
  }
}

export default async function(store) {
  let winecatalog = store.getters['getAdHocStorageValue']('winecatalog')

  await store.dispatch('catalogues/loadCatalogues')

  if (winecatalog !== undefined) {
    applogger.debug('Wine catalog loader already complete')
    return Promise.resolve(winecatalog)
  }

  // let products = store.getters['products/all']
  //
  // if (products.length > 0) {
  //   applogger.debug('Wine catalog loader already complete')
  //   return Promise.resolve(products)
  // }

  const __loader = () => {
    return asyncLoader(store)
      .then(_ => store.dispatch('products/findByType', 'wine_product'))
      .then(winecatalog => {
        const sortOrder = store.getters['blob/get']('wine-product-sort-order')
        const sortedWineCatalog = sortProductCatalog(winecatalog, sortOrder)

        store.commit('STORE_ADHOC_STORAGE', { key: 'winecatalog', data: sortedWineCatalog })

        applogger.debug('Wine catalog loader complete')
        return sortedWineCatalog
      })
  }

  return store.dispatch('promisePool', {
    name: 'wine-product-catalog',
    resolve: __loader
  })
}
